import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import ReactSlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { useCreateOrUpdateStatutoryComponents } from "../../queries/payrollQuries";
import { toast } from "react-toastify";
import { closeIcon } from "../../Icons/Icons";
import { useGetStateList } from "../../queries/employeeQueries";

import {
  calculationBasisOptions,
  calculationTypeOptions,
  statutoryComponentTypeOptions,
} from "../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
import {
  SALARY_COMPONENT_TYPES,
  SALARY_COMPONENT_CALCULATION,
} from "../../redux/constants/payrollComponents";
import { Tooltip } from "antd";
import { infoIcon } from "../../Icons/Icons";

// adding %

const AddStatutoryComponents = ({ closePane, editData }) => {
  const [selectedEmployeeTypes, setSelectedEmployeeTypes] = useState([]);

  useEffect(() => {
    if (editData && Array.isArray(editData.employee_type_ids)) {
      setSelectedEmployeeTypes(editData.employee_type_ids.map(Number));
    }
  }, [editData]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      conponentId : editData?.component_id || null,
      componentName: editData?.component_name || "",

      calculationType: editData
        ? calculationTypeOptions.find(
            (opt) => opt.value === Number(editData?.calculation_type)
          )
        : null,

      calculationBasis: editData
        ? calculationBasisOptions.find(
            (opt) => opt.value === String(editData?.calculation_basis)
          )
        : null,
      statutoryComponentType: editData
        ? statutoryComponentTypeOptions.find(
            (opt) => opt.value === Number(editData?.statutory_type)
          )
        : null,

      description: editData?.description || "",
      employeeRate: editData?.employee_rate || "",
      employerRate: editData?.employer_rate || "",
      maxLimit:
        editData?.max_limit != null ? parseFloat(editData?.max_limit) : "",
      hideInPayslip: editData?.hide_in_payslip || false,
      isMandatory: editData?.is_mandatory || true,
      isRestricted: editData?.is_restricted || false,
    },
  });

  const [isActive, setIsActive] = useState(true);
const [isRestricted, setIsRestricted] = useState(
  editData ? Boolean(editData.is_restricted) : false
);

  const IndiaCountryCode = 101;

  const [selectedState, setSelectedState] = useState(editData?.state_id || "");
  const { data: stateList } = useGetStateList(IndiaCountryCode);

  const getErrorMessage = (field) => {
    return errors[field]?.message || "";
  };

  const stateOptions =
    stateList?.map((state) => ({
      label: state.state_name,
      value: state.id,
    })) || [];

  useEffect(() => {
    if (editData && editData.hasOwnProperty("is_active")) {
      setIsActive(editData.is_active === true || editData.is_active === "true");
    }
  }, [editData]);

  const createStatutoryComponent = useCreateOrUpdateStatutoryComponents();

  const onSubmit = (data) => {
    const payload = {
      component_id : data?.conponentId,
      component_name: data?.componentName,
      component_type: SALARY_COMPONENT_TYPES.DEDUCTION,
      calculation_type: Number(data.calculationType.value),
      statutory_type: data?.statutoryComponentType?.value,
      hide_in_payslip: data?.hideInPayslip.toString(),
      is_active: isActive.toString(),
      description: data?.description,
      is_restricted: isRestricted.toString(),
      max_limit: data?.maxLimit ? parseFloat(data.maxLimit) : 0.0,

      employee_rate: parseFloat(data?.employeeRate),
      employer_rate: parseFloat(data?.employerRate),
      calculation_basis: data?.calculationBasis?.value, // frequency of calculation
      state_id: selectedState,
    };
    createStatutoryComponent.mutate(payload, {
      onSuccess: (response) => {
        toast.success(
          response.message || "Created statutory component successfully"
        );
        closePane();
      },
      onError: (error) => {
        toast.error(
          error?.response?.data?.message ||
            "Error while creating statutory component"
        );
      },
    });
  };

  return (
    <ReactSlidingPane isOpen onRequestClose={closePane} width="450px">
      <div className="flex justify-between items-center px-5 border-b py-3">
        <h1 className="font-medium">
          {editData ? "Edit" : "Add"} Statutory Component
        </h1>
        <button onClick={closePane}>{closeIcon}</button>
      </div>

      <div className="p-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Component Name */}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Component Name
              </label>
              <Tooltip title="Enter the name of the statutory component (e.g., EPF, ESI, PT)">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <input
              type="text"
              className="border p-2 w-full"
              {...register("componentName", {
                required: "This field is required",
              })}
            />
            <p className="text-red-500 text-xs">
              {getErrorMessage("componentName")}
            </p>
          </div>

          {/* Calucation type*/}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Calculation Type
              </label>
              <Tooltip title="Select how the deduction is calculated (e.g., fixed amount, percentage, auto).">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <Controller
              name="calculationType"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={calculationTypeOptions.filter(
                    (opt) =>
                      opt.value !== SALARY_COMPONENT_CALCULATION.AUTO_CALCULATED
                  )}
                  placeholder="Select Calculation Type"
                />
              )}
            />
            <p className="text-red-500 text-xs">
              {getErrorMessage("calculationType")}
            </p>
          </div>

          {/* Statutory   type*/}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Statutory Type
              </label>
             <Tooltip title="Select the statutory type to apply its specific calculation rules such as ESI, EPF, etc.">
  <span className="cursor-pointer">{infoIcon}</span>
</Tooltip>
            </div>
            <Controller
              name="statutoryComponentType"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={statutoryComponentTypeOptions}
                  placeholder="Select Statutory Component Type"
                />
              )}
            />

            <p className="text-red-500 text-xs">
              {getErrorMessage("statutoryComponentType")}
            </p>
          </div>
          {/* Employee Rate */}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Employee Rate</label>
              <Tooltip title="Rate deducted from the employee’s salary. Must be between 0 and 100.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <input
              type="number"
              step="0.01"
              className="border p-2 w-full"
              {...register("employeeRate", {
                required: "This field is required",
                min: { value: 0, message: "Cannot be less than 0" },
                validate: (value) => {
                  const calcType = watch("calculationType")?.value;
                  if (
                    calcType === SALARY_COMPONENT_CALCULATION.PERCENTAGE &&
                    value > 100
                  ) {
                    return "Percentage cannot be more than 100";
                  }
                  return true;
                },
              })}
            />
            <p className="text-red-500 text-xs">
              {getErrorMessage("employeeRate")}
            </p>
          </div>

          {/* Employer Rate */}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Employer Rate{" "}
              </label>
              <Tooltip title="Rate deducted from the employer’s salary. Must be between 0 and 100.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <input
              type="number"
              step="0.01"
              className="border p-2 w-full"
              {...register("employerRate", {
                required: "This field is required",
                min: { value: 0, message: "Cannot be less than 0" },
                validate: (value) => {
                  const calcType = watch("calculationType")?.value;
                  if (
                    calcType === SALARY_COMPONENT_CALCULATION.PERCENTAGE &&
                    value > 100
                  ) {
                    return "Percentage cannot be more than 100";
                  }
                  return true;
                },
              })}
            />
            <p className="text-red-500 text-xs">
              {getErrorMessage("employerRate")}
            </p>
          </div>

          {/* Max Limit */}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Max Limit</label>
              <Tooltip title="Maximum value applicable for the deduction (e.g., ₹15,000 for PF). Leave empty if unlimited.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
          <input
  type="number"
  step="0.01"
  className="border p-2 w-full"
  {...register("maxLimit", {
    setValueAs: (v) => (v === "" || v == null ? 0.0 : parseFloat(v)),
    validate: (value) =>
      value >= 0 || "Max limit cannot be negative",
  })}
/>

            <p className="text-red-500 text-xs">
              {getErrorMessage("maxLimit")}
            </p>
          </div>

          {/* Frequency */}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Frequency Of Calculation
              </label>
              <Tooltip title="Select how often this component should be calculated, such as monthly, quarterly, or annually.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>

            <Controller
              name="calculationBasis"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={calculationBasisOptions}
                  placeholder="Select"
                />
              )}
            />

            <p className="text-red-500 text-xs">
              {getErrorMessage("calculationBasis")}
            </p>
          </div>

          {/* State */}
          <div className="mb-4">
            <label className="block text-sm font-medium">Select State</label>
            <select
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
              className="border p-2 w-full"
            >
              <option value="">Select State</option>
              {stateOptions.map((state) => (
                <option key={state.value} value={state.value}>
                  {state.label}
                </option>
              ))}
            </select>

            <p className="text-red-500 text-xs">{getErrorMessage("state")}</p>
          </div>

          {/* Is Active */}
          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Is Active</label>
              <Tooltip title="Enable to make this component available for salary calculations.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <ToggleSwitch checked={isActive} getToggleState={setIsActive} />
          </div>

          {/* Hide In Payslip */}

          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Hide In Payslip
              </label>
              <Tooltip title="Enable this to hide the component from the employee's payslip.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
            <ToggleSwitch
              checked={watch("hideInPayslip")}
              getToggleState={(state) => setValue("hideInPayslip", state)}
            />
          </div>

          {/* Is Restricted */}
          <div className="mb-4 flex items-center">
            <input
              id="isRestricted"
              type="checkbox"
              className="mr-2"
              checked={isRestricted}
              onChange={(e) => setIsRestricted(e.target.checked)}
            />
            <div className="flex items-center gap-1">
              <label htmlFor="isRestricted" className="text-sm font-medium">
                Is Restricted
              </label>
              <Tooltip title="If enabled, PF will be calculated with a cap (e.g., ₹15,000 max). Otherwise, it is based on total eligible components.">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>
          </div>

          {/* Applicable For ==> Not considering now */}
          {/* <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">
                Applicable For
              </label>
              <Tooltip title="Select the employment types this component applies to (e.g., Full-time, Part-time, Interns).">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>

            {employeeTypeListLoading ? (
              <p>Loading employee types...</p>
            ) : (
              <div
                className="flex flex-wrap gap-4 mt-2"
                onFocus={() => handleFocus("applicable_for")}
                onBlur={() => handleBlur("applicable_for")}
                tabIndex={0}
              >
                {employeeTypeListOptions.map((option) => (
                  <div key={option.id} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      value={option.id}
                      checked={selectedEmployeeTypes.includes(option.id)}
                      onChange={() => handleEmployeeTypeChange(option.id)}
                    />
                    <label>{option.type_label}</label>
                  </div>
                ))}
              </div>
            )}
            <p className="text-red-500 text-xs">
              {selectedEmployeeTypes.length === 0 &&
                getErrorMessage("applicable_for")}
            </p>
          </div> */}

          {/* Description */}
          <div className="mb-4">
            <div className="flex items-center gap-1">
              <label className="block text-sm font-medium">Description</label>
              <Tooltip title="Provide a short explanation or notes for this component (e.g., its purpose or usage).">
                <span className="cursor-pointer">{infoIcon}</span>
              </Tooltip>
            </div>

            <textarea
              className="border p-2 w-full"
              {...register("description", {
                required: "This field is required",
              })}
            />
            {errors.description && (
              <p className="text-red-500 text-xs">
                {errors.description.message}
              </p>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              type="button"
              className="bg-gray-500 text-white px-4 py-2 rounded"
              onClick={closePane}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`px-4 py-2 rounded text-white transition duration-200 ${
                createStatutoryComponent.isLoading
                  ? "bg-blue-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
              disabled={createStatutoryComponent.isLoading}
            >
              {createStatutoryComponent.isLoading
                ? editData
                  ? "Updating..."
                  : "Adding..."
                : editData
                ? "Update"
                : "Add"}{" "}
              Statutory Component
            </button>
          </div>
        </form>
      </div>
    </ReactSlidingPane>
  );
};

export default AddStatutoryComponents;
